<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Категории баннеров"
    >
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="bannersData"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #top>
          <v-toolbar flat>
            <v-dialog v-model="dialog">
              <template #activator="{ on, attrs }">
                <v-btn
                  color="red"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Новая запись
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Добавление категории</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-text-field
                      v-model="editedItem.slug"
                      label="Url"
                    />
                    <v-text-field
                      v-model="editedItem.name"
                      label="Название"
                    />
                    <v-text-field
                      v-model="editedItem.description"
                      label="Описание"
                    />
                    <v-select
                      v-model="editedItem.status"
                      :items="statusList"
                      label="Статус"
                      single-line
                    />
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Отмена
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
import { banner_areas, createBannerCategory, deleteBannerArea } from '@/graphql/banners'
import { startCase } from 'lodash-es'

export default {
  name: 'Banners',
  layout: 'dashboard',
  apollo: {
    banner_areas: {
      query: banner_areas,
      variables () {
        return this.getBannersQueryVariables()
      },
      update (data) {
        return data.bannerAreas.data
      },
      result ({ data }) {
        this.totalCount = data.bannerAreas.totalCount
      }
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      totalCount: 0,
      selectedCategory: null,
      deleteDialog: false,
      editedItem: {},
      statusList: ['PUBLISHED', 'DRAFT', 'DELETED'],
      headers: [
        ['slug', 'Url'],
        ['name', 'Название'],
        ['status', 'Статус'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          })
    }
  },
  computed: {
    bannersData () {
      return this.banner_areas ?? []
    }
  },
  watch: {
    selectedCategory () {
      this.options.page = 1
    }
  },
  methods: {
    getBannersQueryVariables () {
      return {
        limit: this.options.itemsPerPage,
        offset: this.options.itemsPerPage * (this.options.page - 1)
      }
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    save () {
      this.$apollo
          .mutate({
            mutation: createBannerCategory,
            variables: {
              input: this.editedItem
            }
          })
          .then((data) => {
            this.$apollo.queries.banner_areas.refetch()
          })
          .catch((error) => {
            console.error(error)
          })

      this.close()
    },
    deleteBannerCategory (slug) {
      this.$apollo
        .mutate({
          mutation: deleteBannerArea,
          variables: {
            slug
          }
        })
        .then((data) => {
          this.$apollo.queries.banner_areas.refetch()
        })
        .catch((error) => {
          console.error(error)
        })
    },
    close () {
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>
